module.exports = __webpack_public_path__ + "entry-150bfe9b/dis-photo-91622d820ae0031674841e658670ae59.webp";